export default __webpack_public_path__ + "static/media/calendarIcon.77dcd590.svg";